import {ReactNode, useCallback, useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {FlowClockContext} from '../hooks/useFlowClock';

// FNP-412: restarts the flow clock when the operator moves to another flow;
// Start Over restarts it through the context.
export const FlowClockProvider = ({children}: { children: ReactNode }) => {
    const {pathname} = useLocation();
    const [startedAt, setStartedAt] = useState(() => new Date());
    const restart = useCallback(() => setStartedAt(new Date()), []);

    // Restart only when the route changes, not on mount: the initial state is
    // already "now", and a second Date would change the panel's query key.
    const previousPath = useRef(pathname);
    useEffect(() => {
        if (previousPath.current === pathname) return;
        previousPath.current = pathname;
        restart();
    }, [pathname, restart]);

    return (
        <FlowClockContext.Provider value={{startedAt, restart}}>
            {children}
        </FlowClockContext.Provider>
    );
};
